import styled from "styled-components";

const AssetSizes = { width: "70px", height: "70px" };
const LogoAssetSizes = { width: "125px", height: "60px" };

export const AssetsUploadWrapper = styled.section`
  display: flex;
  gap: 10px;
  padding: 17px 7px 7px 7px;
  flex-wrap: wrap;
  justify-content: left;
`;

export const AssetWrapper = styled.div`
  position: relative;
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: 5px;
  left: 7px;
`;

export const Asset = styled.div`
  padding: 10px;
  background-origin: content-box !important;
  width: ${({ isLogo }) => (isLogo ? LogoAssetSizes.width : AssetSizes.width)};
  height: ${({ isLogo }) => (isLogo ? LogoAssetSizes.height : AssetSizes.height)};
  background: ${({ src, theme }) =>
    `url(${src}) ${theme.colors.campaignMediaAssets.mediaAssetBgColor} 50% / contain no-repeat`};
  border-radius: 10px;

  cursor: pointer;
  transition: all 0.3s ease;
  :hover {
    transform: scale(1.05);
  }
`;

export const EmptyAsset = styled(Asset)`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.campaignMediaAssets.mediaAssetBgColor};
  padding: 0;
`;

export const UploadAssetButton = styled.label`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
